import { Sparkles } from "lucide-react";

const MESSAGES: { role: "ai" | "user"; text: string }[] = [
  { role: "ai", text: "I noticed 3 meals over $75 last week. Want me to flag them for review?" },
  { role: "user", text: "Yes, flag meals > $50 going forward." },
  { role: "ai", text: "Policy updated — I'll apply that to new expenses and back-check the last 30 days." },
  { role: "ai", text: "Found 2 flagged items: Nobu dinner $112 (Oct 14) and client lunch $88 (Oct 16). Added to review queue." },
  { role: "user", text: "Great, approve the Oct 16 one — that had a client present." },
];
const CHIPS = ["Summarize April expenses", "Find duplicate receipts", "Draft audit packet"];

export function AIPanel() {
  return (
    <div className="flex flex-col h-full bg-white">
      {/* Header */}
      <div className="flex items-center gap-2 px-4 py-3 border-b border-[var(--ink-200)] shrink-0">
        <div className="w-8 h-8 rounded-full bg-[var(--brand-50)] flex items-center justify-center">
          <Sparkles className="w-4 h-4 text-[var(--brand-700)]" strokeWidth={1.8} />
        </div>
        <div>
          <div className="text-sm font-semibold text-[var(--ink-950)]">Proofly AI</div>
          <div className="flex items-center gap-1 text-[11px] text-[var(--success)]">
            <span className="w-1.5 h-1.5 rounded-full bg-[var(--success)] inline-block" />
            Online
          </div>
        </div>
      </div>
      {/* Messages */}
      <div className="flex-1 overflow-auto px-4 py-4 space-y-3">
        {MESSAGES.map((m, i) => (
          <div key={i} className={["flex", m.role === "user" ? "justify-end" : "justify-start"].join(" ")}>
            <div
              className={[
                "max-w-[80%] rounded-2xl px-3.5 py-2.5 text-sm leading-relaxed",
                m.role === "user"
                  ? "bg-[var(--ink-950)] text-white rounded-br-sm"
                  : "bg-[var(--ink-100)] text-[var(--ink-900)] rounded-bl-sm",
              ].join(" ")}
            >
              {m.text}
            </div>
          </div>
        ))}
      </div>
      {/* Suggestion chips */}
      <div className="px-4 pb-2 flex gap-2 flex-wrap shrink-0">
        {CHIPS.map((c) => (
          <span
            key={c}
            className="text-xs font-medium border border-[var(--brand-200)] text-[var(--brand-700)] bg-[var(--brand-50)] px-2.5 py-1 rounded-full"
          >
            {c}
          </span>
        ))}
      </div>
      {/* Input */}
      <div className="px-4 pb-4 shrink-0">
        <div className="flex items-center gap-2 h-10 px-3 rounded-xl border border-[var(--ink-200)] bg-[var(--ink-50)]">
          <span className="text-sm text-[var(--ink-400)] flex-1">Ask Proofly AI…</span>
          <Sparkles className="w-4 h-4 text-[var(--ink-300)]" strokeWidth={1.5} />
        </div>
      </div>
    </div>
  );
}
